import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-5x" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text mt-6" }, [
  /*#__PURE__*/_createTextVNode(" Suelte el archivo aquí o "),
  /*#__PURE__*/_createElementVNode("em", null, "haga clic para cargar")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip text-center" }, " Archivos JPG/PNG con un tamaño inferior a 500 KB ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $setup.dialogPhoto,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dialogPhoto) = $event)),
    title: "Subir archivo",
    class: "bg-light",
    center: "",
    draggable: "",
    "close-on-click-modal": false,
    onClosed: $setup.onClosed
  }, {
    header: _withCtx(({ titleId, titleClass }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, "Subir archivo", 10, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_upload, {
        ref: "upload",
        drag: "",
        headers: $setup.headers,
        data: $setup.gblDataPhoto,
        name: "file",
        action: `${$setup.urlUpload}/api/file/upload`,
        accept: ".png, .jpg",
        limit: 1,
        multiple: false,
        "before-upload": $setup.beforeUpload,
        "on-error": $setup.handleError,
        "on-success": $setup.handleSuccess
      }, {
        tip: _withCtx(() => [
          _hoisted_5
        ]),
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }, 8, ["headers", "data", "action", "before-upload", "on-error", "on-success"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
}